import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class Carousel extends Vue {
    interval: any = null;
    enableTransition: boolean = true;
    activeSlides: any[] = [];

    @Prop({default: []}) slides!: any[];
    

    get pages(){

      const withActive = this.activeSlides.map((slide, idx) => {
        
        const newSlide = {...slide};

        if (idx === 0){

          newSlide.active = true;

        } else {

          newSlide.active = false;

        }

        return newSlide
      })

      return withActive.sort((prev, next) => prev.id - next.id);

    }

    changeSlide(id: number){
      
      this.enableTransition = false;

      const idx = this.activeSlides.findIndex(slide => slide.id === id);
      
      const nextSlides = this.activeSlides.slice(idx, this.activeSlides.length);
      const firstSlides = this.activeSlides.slice(0, idx);

      this.activeSlides = [...nextSlides, ...firstSlides]


    }

    next(){

      this.interval = clearInterval(this.interval);
      this.enableTransition = true;

      const first = this.activeSlides.slice(0, 1)
      const activeSlides = this.activeSlides.slice(1)
      activeSlides.push(...first);

      this.activeSlides = activeSlides;

      this.interval = setInterval(this.next, 20000);

    }

    previous(){
      this.interval = clearInterval(this.interval);
      this.enableTransition = true;

      const last = this.activeSlides.pop();
      this.activeSlides = [last].concat(this.activeSlides);

      this.interval = setInterval(this.next, 20000);

    }

    created(){
      this.activeSlides = this.slides;
    }

    mounted(){
      this.interval = setInterval(this.next, 5000);
    }

    begoreDestroy(){
      this.interval = clearInterval(this.interval);
    }
}